module.exports = __webpack_public_path__ + "static/media/barca (2).222c45fd.jpg";